module.exports = __webpack_public_path__ + "img/ValidationReport_5.0ee68bb6.jpg";